/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Outcome_Credit_NoteInputs */

const en_claim_outcome_credit_note = /** @type {(inputs: Claim_Outcome_Credit_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit note`)
};

/**
* | output |
* | --- |
* | "Credit note" |
*
* @param {Claim_Outcome_Credit_NoteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_outcome_credit_note = /** @type {((inputs?: Claim_Outcome_Credit_NoteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Outcome_Credit_NoteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_outcome_credit_note(inputs)
});